import { API_ASSETS_ROUTE } from '../config/routes/assets';

export const bookAnAppointmentBackground = `${API_ASSETS_ROUTE}/book-an-appointment.jpeg`;
